import { Routes } from '@angular/router';
import { HomeComponent } from './home.component';

export const ModuleRoutes: Routes = [
    {
        path: '',
        component: HomeComponent
    }
]
